import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  addNewExtra,
  addNewExtraItem,
  deleteExtra,
  getListExtraProduct,
  getProductDetail,
} from "../../../../redux/actions/productActions";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import Paginate from "../../../../components/Paginate";
import Alert from "../../../../components/Alert";
import Loader from "../../../../components/Loader";
import ConfirmationModal from "../../../../components/ConfirmationModal";
import { toast } from "react-toastify";

function ExtraProductScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || "1";

  const [eventType, setEventType] = useState("");
  const [extraId, setExtraId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const [extraSelect, setExtraSelect] = useState(null);
  const [loadEvent, setLoadEvent] = useState(false);

  const [extraName, setExtraName] = useState("");
  const [extraNameError, setExtraNameError] = useState("");

  const [extraOption, setExtraOption] = useState("");
  const [extraOptionError, setExtraOptionError] = useState("");

  const [itemName, setItemName] = useState("");
  const [itemNameError, setItemNameError] = useState("");

  const [itemPrice, setItemPrice] = useState("");
  const [itemPriceError, setItemPriceError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productDetail = useSelector((state) => state.detailProduct);
  const {
    loadingProductInfo,
    errorProductInfo,
    successProductInfo,
    productInfo,
  } = productDetail;

  const listProductExtra = useSelector((state) => state.listExtraProduct);
  const { extras, loadingListExtraProduct, errorListExtraProduct, pages } =
    listProductExtra;

  const extraDelete = useSelector((state) => state.deleteExtra);
  const {
    loadingProductExtraDelete,
    errorProductExtraDelete,
    successProductExtraDelete,
  } = extraDelete;

  const extraCreate = useSelector((state) => state.createNewExtra);
  const {
    loadingProductExtraAdd,
    errorProductExtraAdd,
    successProductExtraAdd,
  } = extraCreate;

  const extraItemCreate = useSelector((state) => state.createNewExtraItem);
  const {
    loadingProductExtraItemAdd,
    errorProductExtraItemAdd,
    successProductExtraItemAdd,
  } = extraItemCreate;

  const redirect = "/";
  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    } else {
      dispatch(getProductDetail(id));
      dispatch(getListExtraProduct(page, id));
    }
  }, [navigate, userInfo, dispatch, id]);

  useEffect(() => {
    if (successProductExtraDelete) {
      dispatch(getProductDetail(id));
      dispatch(getListExtraProduct("1", id));
    }
  }, [successProductExtraDelete]);

  useEffect(() => {
    if (successProductExtraAdd) {
      dispatch(getProductDetail(id));
      dispatch(getListExtraProduct("1", id));
      setExtraName("");
      setExtraOption("");
    }
  }, [successProductExtraAdd]);

  useEffect(() => {
    if (successProductExtraItemAdd) {
      dispatch(getProductDetail(id));
      dispatch(getListExtraProduct(page, id));
      setIsOpenAdd(false);
      setItemName("");
      setItemPrice("");
      setExtraSelect(null);
    }
  }, [successProductExtraItemAdd]);

  return (
    <DefaultLayout>
      <div>
        <div className="flex flex-row text-sm items-center my-1">
          {/* home */}
          <a href="/dashboard">
            <div className="flex flex-row  items-center hover:text-black ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
              <span className="mx-1">Dashboard</span>
            </div>
          </a>
          <div className="flex flex-row  items-center hover:text-black ">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </span>
            <a href="/products">
              <div className="">Products List</div>
            </a>
          </div>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </span>
          <div className="">Product Extra</div>
        </div>
        {/*  */}
        <div className="flex flex-row justify-between  items-center my-3">
          <div className="mx-1 font-bold text-black ">
            Product Extra {extras.length}
          </div>
        </div>
        {/*  */}
        <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default  ">
          <div className="container mx-auto flex flex-col">
            <div className="flex md:flex-row flex-col  ">
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Extra Name <strong className="text-danger">*</strong>
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      extraNameError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="text"
                    placeholder="Extra Name"
                    value={extraName}
                    onChange={(v) => setExtraName(v.target.value)}
                  />
                  <div className=" text-[8px] text-danger">
                    {extraNameError ? extraNameError : ""}
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Extra Option <strong className="text-danger">*</strong>
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      extraOptionError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="text"
                    placeholder="Extra Option"
                    value={extraOption}
                    onChange={(v) => setExtraOption(v.target.value)}
                  />
                  <div className=" text-[8px] text-danger">
                    {extraOptionError ? extraOptionError : ""}
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="my-3 ">
              <div className="flex flex-row items-center justify-end my-3">
                <button
                  onClick={async () => {
                    setExtraName("");
                    setExtraNameError("");
                    setExtraOption("");
                    setExtraOptionError("");
                  }}
                  className="text-white bg-danger text-sm px-5 py-2 mx-2 rounded-full"
                >
                  Cancel
                </button>
                <button
                  onClick={async () => {
                    var check = true;
                    setExtraNameError("");
                    setExtraOptionError("");

                    if (extraName === "") {
                      setExtraNameError("This field is required.");
                      check = false;
                    }

                    if (extraOption === "") {
                      setExtraOptionError("These fields are required.");
                      check = false;
                    }

                    if (check) {
                      // setLoadEvent(true);
                      await dispatch(
                        addNewExtra(id, {
                          extra_title: extraName,
                          extra_subtitle: extraOption,
                        })
                      ).then(() => {});
                      // setLoadEvent(false);
                    } else {
                      toast.error(
                        "Some fields are empty or invalid. please try again"
                      );
                    }
                  }}
                  className="text-white bg-[#0388A6] text-sm px-5 py-2 mx-2 rounded-full"
                >
                  {loadingProductExtraAdd ? "Loading ..." : "Create Extra"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default  ">
          <div className="container mx-auto flex flex-col">
            {/*  */}
            <div className="w-full overflow-x-auto ">
              <table className="w-full table-auto">
                <thead>
                  <tr className=" bg-[#F3F5FB] text-left ">
                    <th className="min-w-[30px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      #
                    </th>

                    <th className="min-w-[120px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      Extra Name
                    </th>
                    <th className="min-w-[120px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max ">
                      Extra Option
                    </th>
                    <th className="min-w-[120px] py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      Items
                    </th>
                    <th className="py-4 px-4 font-bold text-[#8E8E8E] text-xs w-max">
                      Operations
                    </th>
                  </tr>
                </thead>
                {/*  */}
                <tbody>
                  {loadingListExtraProduct ? (
                    <Loader />
                  ) : errorListExtraProduct ? (
                    <Alert message={errorListExtraProduct} />
                  ) : (
                    extras?.map((item, index) => (
                      <tr key={index}>
                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            #{item.id}
                          </p>
                        </td>

                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            {item.extra_title ?? "---"}
                          </p>
                        </td>
                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            {item.extra_subtitle ?? "---"}
                          </p>
                        </td>
                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max  ">
                            {item.extra_items.length ?? "O"} - Items
                          </p>
                        </td>

                        <td className=" py-1 px-4 min-w-[120px]  ">
                          <p className="text-black  text-xs w-max flex flex-row  ">
                            <div
                              onClick={() => {
                                setEventType("delete-extra");
                                setExtraId(item.id);
                                setIsOpen(true);
                              }}
                              className="mx-1 delete-class cursor-pointer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="w-5 h-5 bg-danger rounded p-1 text-white text-center text-xs"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                                />
                              </svg>
                            </div>
                            {/* extra */}
                            <div
                              onClick={() => {
                                setExtraSelect(item);
                                setIsOpenAdd(true);
                              }}
                              className="mx-1 extraitem-class cursor-pointer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="w-5 h-5 bg-primary rounded p-1 text-white text-center text-xs"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
                                />
                              </svg>
                            </div>
                          </p>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="">
              <Paginate
                route={`/products/extras/${id}?`}
                search={""}
                page={page}
                pages={pages}
              />
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 w-full container mt-5"></div>

        {isOpenAdd ? (
          <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-99999 bg-black bg-opacity-20">
            <div className="bg-white p-6 rounded shadow-md mx-3">
              <h3 className="text-lg font-bold mb-4">
                Add Extra Items: {extraSelect.extra_title ?? ""}{" "}
              </h3>
              <div>
                <div className="container mx-auto flex flex-col">
                  <div className="flex flex-col  ">
                    <div className=" w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Item Name <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          className={` outline-none border ${
                            itemNameError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type="text"
                          placeholder="Item Name"
                          value={itemName}
                          onChange={(v) => setItemName(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {itemNameError ? itemNameError : ""}
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className=" w-full  md:pr-1 my-1">
                      <div className="text-[#000000bf] font-bold text-xs  mb-1">
                        Item Price <strong className="text-danger">*</strong>
                      </div>
                      <div>
                        <input
                          className={` outline-none border ${
                            itemPriceError
                              ? "border-danger"
                              : "border-[#979fd38a]"
                          } px-3 py-2 w-full rounded text-sm`}
                          type="number"
                          min={0}
                          step={0.01}
                          placeholder="Item Price"
                          value={itemPrice}
                          onChange={(v) => setItemPrice(v.target.value)}
                        />
                        <div className=" text-[8px] text-danger">
                          {itemPriceError ? itemPriceError : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="my-3 ">
                    <div className="flex flex-row items-center justify-end my-3">
                      <button
                        onClick={async () => {
                          setItemName("");
                          setItemNameError("");
                          setItemPrice("0");
                          setItemPriceError("");
                        }}
                        className="text-white bg-danger text-sm px-5 py-2 mx-1 rounded-full"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={async () => {
                          var check = true;
                          setItemNameError("");
                          setItemPriceError("");

                          if (itemName === "") {
                            setItemNameError("This field is required.");
                            check = false;
                          }

                          if (itemPrice === "") {
                            setItemPriceError("These fields are required.");
                            check = false;
                          }

                          if (check) {
                            // setLoadEvent(true);
                            await dispatch(
                              addNewExtraItem(extraSelect.id, {
                                item_name: itemName,
                                item_price: itemPrice,
                              })
                            ).then(() => {});
                            // setLoadEvent(false);
                          } else {
                            toast.error(
                              "Some fields are empty or invalid. please try again"
                            );
                          }
                        }}
                        className="text-white bg-[#0388A6] text-sm px-5 py-2 mx-1 rounded-full"
                      >
                        {loadingProductExtraAdd ? "Loading ..." : "Create Item"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <ConfirmationModal
          isOpen={isOpen}
          message={
            eventType === "delete-extra"
              ? "Are you sure you want to delete this product?"
              : "Are you sure ?"
          }
          onConfirm={async () => {
            if (eventType === "cancel") {
              setIsOpen(false);
              setEventType("");
              setLoadEvent(false);
              setExtraId("");
            } else if (eventType === "delete-extra" && extraId !== "") {
              setLoadEvent(true);
              dispatch(deleteExtra(extraId));
              setIsOpen(false);
              setEventType("");
              setLoadEvent(false);
            } else {
              setIsOpen(false);
              setEventType("");
              setLoadEvent(false);
              setExtraId("");
            }
          }}
          onCancel={() => {
            setIsOpen(false);
            setEventType("");
            setLoadEvent(false);
            setExtraId("");
          }}
          loadEvent={loadEvent}
        />
      </div>
    </DefaultLayout>
  );
}

export default ExtraProductScreen;
